import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useOutputDetailsModel } from "./outputDetailsModel"
import { DetailType } from "@/types/ScmEnums";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { detailLookForm, getDetailLookOne } = useOutputDetailsModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();

    useEffect(() => {
        console.log(id, mode)
        mode == DetailType.look && getDetailLookOne(id, mode)
    }, [id, mode])
    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "单据编号",
                fieldLabel: Locale["Stock-out Doc No."],
                fieldName: "tradeCode",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "制单时间",
                fieldLabel: Locale["Creation Time"],
                fieldName: "billingTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "出库时间",
                fieldLabel: Locale["Stock-out Time"],
                fieldName: "stockIoTime",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "单据类型",
                fieldLabel: Locale["Document  Type"],
                fieldName: "tradeTypeName",
                disable: true,
            }
        ]
    };
    const poFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: { ...detailLookForm },
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}